import { render, staticRenderFns } from "./InformacionGeneralEvaluacionSection.vue?vue&type=template&id=6366c13e"
import script from "./InformacionGeneralEvaluacionSection.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralEvaluacionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports